import React, { useContext } from "react";
import NavBar from "../../Components/NavBar";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import PrivacyTermsContent from "../../Components/PrivacyTermsContent/PrivacyTermsContent";
import { LanguageContext } from "../../Hooks/langugaeContext.js";
import { useTranslation } from "../../Hooks/useTranslation";

import { termsDataConst } from "../../constants/PrivacyTermsConst";

function TermsOfUse() {
  const translations = useTranslation();
  const { language, toggleLanguage } = useContext(LanguageContext);
  useAnimateOnScroll();
  return (
    <div>
      <NavBar onlyWhiteBg={true} />
      <PrivacyTermsContent
        title={translations.termsPageTitle}
        content={termsDataConst[language]}
      />
    </div>
  );
}

export default TermsOfUse;
